import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import { getTenders } from '@/actions/tenderData';

export const fetchTenderData = async (
  tenderIds: string[],
  includeEntries?: boolean,
  includeComments?: boolean,
  includeResults?: boolean,
  includeChats?: boolean,
  includeAccesses?: boolean,
  includeVotes?: boolean,
) => {
  const userAccessToken = await getUserAccessToken();
  return getTenders(
    userAccessToken,
    tenderIds,
    includeEntries,
    includeComments,
    includeResults,
    includeChats,
    includeAccesses,
    includeVotes,
  );
};
